import { useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Helmet } from 'react-helmet';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';

import DirectSaleFinancialTabs from '@/components/Movements/DirectSale/DirectSaleFinancial/DirectSaleFinancialTabs';

function FinancialDirectSalePage({ route }: PageProps) {
  const { directSaleId } = useRouteMatch<{ directSaleId: string }>().params;
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DefaultRouteTabs
        route={route.parent}
        permissions={route.permissions}
        baseKey={directSaleId}
        basePath={`/app/movements/directSale/${directSaleId}`}
      >
        <DirectSaleFinancialTabs />
      </DefaultRouteTabs>
    </>
  );
}

export default FinancialDirectSalePage;
